import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Divider, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getLayoutItems } from './items';
const SPACING = 2.5;
/**
 * Mapping of Kratos UI node name to key.
 * Keeps away Kratos naming from the template code.
 */
const nameToKeyMap = {
    identifier: 'email',
    method: 'submit',
    password: 'password',
    provider: 'provider',
};
export const LoginTemplate = ({ children, }) => {
    const { t } = useTranslation('auth');
    const items = getLayoutItems(children, nameToKeyMap);
    return (_jsxs(Stack, { spacing: SPACING, children: [items.messages, items.providerList.length > 0 && (_jsxs(_Fragment, { children: [items.providerList, _jsx(Divider, { sx: { ':before, :after': { borderColor: 'black' } }, children: t('body.flow.dividerText') })] })), items.email, items.password, items.submit] }));
};
